/**
 * The gateway-verdict step. Amber, like Gateways.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';
import { Radio } from 'lucide-react';

import { StepCard, Switch } from '@/components/ui';

import type { DropGenPlanDetail } from '../../../../drop-generator.types';
import { InheritedSection } from '../../master/InheritedSection';
import { useSectionSources } from '../../master/section-sources';
import type { ContainerEditor } from '../../state/useContainerEditor';
import { GatewayVerdictStep, gatewayVerdictSummary } from '../gateway/GatewayVerdictStep';

interface Props {
  index: number;
  editor: ContainerEditor;
  plan: DropGenPlanDetail;
  containerId: string | null;
}

export const GatewayVerdictCard: FC<Props> = ({ index, editor, plan, containerId }) => {
  const own = useSectionSources().isOwn('verdict');
  const { gatewayVerdict } = editor.draft;
  return (
    <StepCard
      index={index}
      tone="amber"
      icon={Radio}
      title="Gateway verdict"
      summary={gatewayVerdictSummary(editor)}
      headerRight={
        <Switch
          checked={gatewayVerdict.enabled}
          disabled={!own}
          onCheckedChange={(enabled) => editor.gatewayVerdictPatch({ enabled })}
          aria-label="Enable the gateway verdict"
        />
      }
    >
      <InheritedSection section="verdict">
        <GatewayVerdictStep editor={editor} plan={plan} containerId={containerId} />
      </InheritedSection>
    </StepCard>
  );
};
